<script>
import axios from '@/utils/axios';

export default {
  inject: ['setLoading'],
  data() {
    return {
      is_edit: false,
      item_id: null,
      option_id: null,
      form: {
        options: [{ name: '', is_required: false, sort_order: 0 }],
      },
    };
  },
  methods: {
    add(item_id) {
      this.is_edit = false;
      this.item_id = item_id;
      this.form.options = [{ name: '', is_required: false, sort_order: 0 }];
    },
    edit(row) {
      this.is_edit = true;
      this.option_id = row.id;
      this.form.options = [{ name: row.name, is_required: !!row.is_required, sort_order: row.sort_order }];
    },
    addRow() {
      this.form.options.push({ name: '', is_required: false, sort_order: 0 });
    },
    removeRow(index) {
      this.form.options.splice(index, 1);
    },
    async submit() {
      this.setLoading(true);
      try {
        if (this.is_edit) {
          await axios.put(`/item-options/${this.option_id}`, this.form.options[0]);
          this.$swalToast('Option updated');
        } else {
          await axios.post('/item-options', { item_id: this.item_id, options: this.form.options });
          this.$swalToast('Option(s) added');
        }
        this.$emit('updated');
        document.querySelector('#item_option_modal .btn-close').click();
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>

<template>
  <div class="modal fade" id="item_option_modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ is_edit ? 'Edit' : 'Add' }} Item Option</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div v-for="(row, index) in form.options" :key="index" class="row align-items-end mb-2 border-bottom pb-2">
            <div class="col-md-5">
              <label class="form-label">Name</label>
              <input type="text" class="form-control" v-model="row.name" placeholder="e.g. Size, Colour" />
            </div>
            <div class="col-md-3">
              <label class="form-label">Sort Order</label>
              <input type="number" class="form-control" v-model.number="row.sort_order" />
            </div>
            <div class="col-md-3">
              <div class="form-check mt-4">
                <input type="checkbox" class="form-check-input" v-model="row.is_required" :id="'req-' + index" />
                <label class="form-check-label" :for="'req-' + index">Required</label>
              </div>
            </div>
            <div class="col-md-1 mt-4" v-if="!is_edit && form.options.length > 1">
              <a href="javascript:void(0)" @click="removeRow(index)">
                <i class="ti ti-trash text-danger"></i>
              </a>
            </div>
          </div>
          <button class="btn btn-outline-primary btn-sm" @click="addRow" v-if="!is_edit">
            <i class="ti ti-plus"></i> Add Another
          </button>
        </div>
        <div class="modal-footer">
          <button class="btn btn-cancel" data-bs-dismiss="modal">Cancel</button>
          <button class="btn btn-submit" @click="submit">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>